export default __webpack_public_path__ + "static/media/img_load_match_profile.95732177.png";